import React from 'react';
import './style.scss';
import { isRTL } from '../../../services/userModel.js';
import classNames from 'classnames';
import { getTranslateTitle } from '../../../utils/objects-util.js';
import EditableTable from '../EditableTable/EditableTable.jsx';
import { connect } from 'react-redux';
import preloader from "../../../assets/images/preloader.GIF";

const SectionItemTranslationTable = ({ t, item, column, onPropChange, isLoading, translationsLanguage }) => {
  return (
    <div className={classNames('sectionItemTranslationTable', { rtl: isRTL() })}>
      <table className={classNames('header')}>
        <tbody>
          <tr>
            {column?.columns?.map((column, index) => {
              return (
                <td
                  key={`headerItem-${column.title}-${index}`}
                  className={classNames('headerItem', {
                    centered: column.centered,
                  })}
                  style={{
                    width: column.width ? `${column.width}` : `auto`,
                    textAlign: column.textRight ? 'right' : '',
                  }}
                >
                  {getTranslateTitle(column.title)}
                  &nbsp;
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      {isLoading && (
        <div className={classNames('loaderWrapper')}>
          <img className='preloader' src={preloader} alt='preloader' />
        </div>
      )}
      <EditableTable virtualized model={column} items={item?.values} isTranslationRtl={translationsLanguage === "he" || translationsLanguage === "ar"} isLoading={false} onPropChange={onPropChange} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isLoading: state.sectionsWrapperData.isLoading,
      translationsLanguage: state.restaurant?.data?.translations?.language
  };
};

export default connect(mapStateToProps)(SectionItemTranslationTable);
